const routes = [
  {
    icon: "ri-truck-line",
    title: "Западный маршрут",
    type: "Трансграничная автодоставка",
    path: "Хоргос / Алашанькоу → Казахстан → РФ",
    points: ["Алматы", "Екатеринбург", "Казань", "Москва"],
    color: "#C9A84C",
  },
  {
    icon: "ri-truck-line",
    title: "Восточный маршрут",
    type: "Трансграничная автодоставка",
    path: "Маньчжурия (Сибирь) / Эрлянь (Монголия)",
    points: ["Чита", "Иркутск", "Красноярск"],
    color: "#C9A84C",
  },
  {
    icon: "ri-train-line",
    title: "Железнодорожный экспресс",
    type: "ЖД через Центральную Азию",
    path: "Западный ЖД коридор",
    points: ["Стабильное транзитное время", "Работает зимой"],
    color: "#C9A84C",
  },
  {
    icon: "ri-ship-line",
    title: "Морской фрахт",
    type: "Океанская линия + Мультимодаль",
    path: "Прямая линия → Санкт-Петербург",
    points: ["Порт Восточный", "Ускоренная ЖД на запад", "Минимальная стоимость единицы"],
    color: "#C9A84C",
  },
];

const standards = [
  {
    icon: "ri-stack-line",
    title: "Минимум 1 поддон",
    desc: "Мы не отправляем грузы россыпью. Минимальный объём — от одного европоддона, обмотанного стрейч-плёнкой (100% сохранность).",
  },
  {
    icon: "ri-box-3-line",
    title: "LCL и FCL грузы",
    desc: "Интеграция от 2 до 10+ поддонов в сборные линии, либо прямая отгрузка целыми контейнерами.",
  },
  {
    icon: "ri-tools-line",
    title: "Кастомная упаковка",
    desc: "Кузовные детали и пластиковый экстерьер требуют кастомных деревянных обрешёток и 3D-оптимизации укладки.",
  },
];

const payment = [
  { route: "Маршрут A", entity: "Guangzhou Chirun", currency: "CNY / USD", desc: "Получатель в КНР. Идеально для клиентов с независимыми каналами конвертации." },
  { route: "Маршрут Б", entity: "ООО «ЯСИН РУС»", currency: "RUB", desc: "Получатель в РФ. Прямой банковский перевод внутри России. Мы берём на себя всю логистику и «белую» растаможку." },
];

export default function LogisticsSection() {
  return (
    <section id="logistics" className="bg-[#060A10] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">Логистика и Таможня</span>
          </div>
          <h2 className="text-white mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(32px, 4.5vw, 60px)", letterSpacing: "0.03em" }}>
            ЭКОСИСТЕМА ЛОГИСТИКИ<br />
            И <span className="text-[#C9A84C]">ТАМОЖЕННОГО КОМПЛАЕНСА</span>
          </h2>
          <p className="text-gray-400 text-base max-w-2xl leading-relaxed">
            Настоящее поле битвы — международная логистика, налоги и легальность таможни. Мы настоятельно призываем к 100% «белой» и легальной торговле. Полный ГТД/НДС, Честный ЗНАК, EAC на каждую поставку.
          </p>
        </div>

        {/* Routes */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
          {routes.map((route) => (
            <div key={route.title} className="bg-[#0D1420] border border-[#1E2A3A] p-6 rounded-sm hover:border-[#C9A84C]/40 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center border border-[#C9A84C]/30 rounded-sm mb-4">
                <i className={`${route.icon} text-[#C9A84C] text-lg`}></i>
              </div>
              <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.2em] uppercase mb-1">{route.type}</div>
              <h3 className="text-white font-bold text-base mb-2" style={{ fontFamily: "'Oswald', sans-serif" }}>{route.title}</h3>
              <p className="text-gray-500 text-xs mb-4 leading-relaxed">{route.path}</p>
              <div className="flex flex-col gap-1.5">
                {route.points.map((point) => (
                  <div key={point} className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-[#C9A84C] rounded-full flex-shrink-0"></div>
                    <span className="text-gray-400 text-xs">{point}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Shipping Standards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-16">
          {standards.map((s) => (
            <div key={s.title} className="flex gap-4 bg-[#0D1420] border border-[#1E2A3A] p-6 rounded-sm">
              <div className="w-10 h-10 flex items-center justify-center border border-[#C9A84C]/30 rounded-sm flex-shrink-0">
                <i className={`${s.icon} text-[#C9A84C] text-lg`}></i>
              </div>
              <div>
                <h4 className="text-white font-bold text-sm mb-2" style={{ fontFamily: "'Oswald', sans-serif" }}>{s.title}</h4>
                <p className="text-gray-500 text-xs leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Payment Routes */}
        <div className="mb-12">
          <h3 className="text-white font-bold text-xl mb-6" style={{ fontFamily: "'Oswald', sans-serif" }}>
            Трёхвалютные расчёты и защита от рисков
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            {payment.map((p) => (
              <div key={p.route} className="bg-[#0D1420] border border-[#1E2A3A] p-6 rounded-sm">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.2em] uppercase">{p.route}</span>
                  <span className="text-white font-black text-lg" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>{p.currency}</span>
                </div>
                <div className="text-white font-semibold text-sm mb-2">{p.entity}</div>
                <p className="text-gray-500 text-xs leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>

          {/* 30/70 Payment Scheme */}
          <div className="bg-[#0D1420] border border-[#C9A84C]/20 p-6 rounded-sm overflow-hidden">
            <div className="flex flex-col md:flex-row gap-6 items-start">
              <div className="flex-1">
                <div className="text-[#C9A84C] text-xs font-semibold tracking-[0.2em] uppercase mb-2">Схема оплаты 30/70</div>
                <div className="flex items-center gap-4 mb-3">
                  <div className="text-center">
                    <div className="text-white font-black text-3xl" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>30%</div>
                    <div className="text-gray-500 text-xs">Депозит</div>
                    <div className="text-gray-600 text-[10px]">Начало сбора груза</div>
                  </div>
                  <div className="flex-1 h-[2px] bg-gradient-to-r from-[#C9A84C] to-[#1E2A3A]"></div>
                  <div className="text-center">
                    <div className="text-white font-black text-3xl" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>70%</div>
                    <div className="text-gray-500 text-xs">Баланс</div>
                    <div className="text-gray-600 text-[10px]">До выхода из порта КНР</div>
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <div className="text-[#C9A84C] text-xs font-semibold tracking-[0.2em] uppercase mb-2">Защита курса CNY</div>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Мы фиксируем кросс-курс в CNY на момент оплаты депозита. Это защищает вашу маржу от волатильности рубля в процессе логистики.
                </p>
              </div>
              <div className="flex-1">
                <div className="text-[#C9A84C] text-xs font-semibold tracking-[0.2em] uppercase mb-2">Proof of Product (POP)</div>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Перед оплатой основного инвойса мы предоставляем фото/видео отчёт о готовности товара на складе с вашим идентификатором.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
